require("bootstrap");

$(document).ready(function() {
    //BOOTSTRAP CAROUSEL
    $("body:not(.website-state-edit) .carousel .carousel-item:first").addClass(
        "active"
    );

    $(".carousel").on("slide.bs.carousel", function(ev) {
        if (ev.relatedTarget) {
            var slideImage = ev.relatedTarget.querySelector(
                "img:not(.b-loaded)"
            );
            if (slideImage !== null) {
                window.bLazy.load(slideImage, true);
            }
        }
    });

    //OWL CAROUSEL (MULTI)
    var enableNav =
        typeof window.OwlEnableNav !== "undefined"
            ? window.OwlEnableNav
            : false;
    $("body:not(.website-state-edit) .owl-carousel:not(.ddi-carousel)").owlCarousel({
        nestedItemSelector: "carousel-item",
        autoplay:
            typeof window.OwlAutoPlay !== "undefined"
                ? window.OwlAutoPlay
                : true,
        autoplayHoverPause: true,
        autoplayTimeout: 2000,
        autoplaySpeed: 500,
        loop: true,
        margin: 30,
        nav: enableNav,
        dotsEach:
            typeof window.OwlDotsEach !== "undefined"
                ? window.OwlDotsEach
                : false,
        navText: [
            "<span class='owl-prev-icon' aria-hidden='true'></span><span class='sr-only'>Forrige</span>",
            "<span class='owl-next-icon' aria-hidden='true'></span><span class='sr-only'>Næste</span>"
        ],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1
            },
            577: {
                items: 2
            },
            993: {
                items: 3
            }
        },
        onInitialized: () => {
            var owlImages = $(".owl-item .carousel-image img");
            var owlDots = $('.owl-dots .owl-dot');
            window.bLazy.load(owlImages, true);

            owlDots.each(function(idx, dot) {
                $(dot).attr('aria-label', 'Naviger til slide ' + (idx + 1));
            });
        }
    });
});
